<template>
    <v-container style="text-align:center;">
        <p>
            可截屏或点击鼠标右键另存二维码图片进行分享（注：用户需先登录再扫码才能直接跳转到课程）。
        </p>
        <div v-if="url">
            <img :src="url" style="width: 100%; height: 100%;">
        </div>
        <div v-if="originUrl">
            <v-text-field v-if="err" v-model="originUrl" readonly />
            <v-btn v-else flat @click="copyUrl">点击复制地址</v-btn>
        </div>
    </v-container>
</template>
<script>
export default {
    name: 'clazz-qrcode',
    props: {
        cfg: Object
    },
    data() {
        return {
            url: null,
            originUrl: null,
            err: false
        }
    },
    methods: {
        init() {
            let self = this, cfg = self.cfg
            if (!cfg || !cfg.clazzId) return
            self.originUrl = `https://mb.anjia365.com/c/index.html?_dl=true&clazz_id=${cfg.clazzId}`
            self.url = `${self.$const.baseUrl}/home/admin/my/tenant/clazz/qrcode/${cfg.clazzId}.png`
        },
        copyUrl() {
            try {
                navigator.clipboard.writeText(this.originUrl)
                this.$status('复制成功', 'success')
            } catch (err) {
                this.$status('无法直接复制，请手工复制', 'error')
                this.err = true
            }
        }
    }, created() {
        this.init()
    }
}
</script>